import axios from 'axios'

import * as actions from "./index"

import {toast} from "react-toastify"

import { push,  } from 'connected-react-router'

export function startVerification(depoId, options={}) {
  console.log(options)
  return function(dispatch) {
    dispatch({type: actions.START_VERIFICATION.PENDING});
    axios.post(`/deposits/${depoId}`, {options: {...options}})
      .then((response) => {
        dispatch({type: actions.START_VERIFICATION.SUCCESS, payload: response.data})
        dispatch(push(`/deposits/${depoId}/verifications/${response.data}`));
      })
      .catch((err) => {
        dispatch({type: actions.START_VERIFICATION.ERROR, payload: err})
      })
  }
}

export function deleteVerification(depo_id, verif_id) {
  console.log("Deleting verification")
  return function(dispatch) {
    dispatch({type: actions.DELETE_VERIFICATION});
    axios.delete("/deposits/"+depo_id+"/verifications/"+verif_id)
      .then((response) => {
        toast.success("Verification deleted")
        dispatch({type: actions.DELETE_VERIFICATION.SUCCESS, payload: response.data})
        dispatch(push('/'));
      })
      .catch((err) => {
        toast.error("Verification delete failed for depot="+depo_id+", verif="+verif_id)
        dispatch({type: actions.DELETE_VERIFICATION.ERROR, payload: err})
      })
  }
}

export function salesforcePush(verif_id, depo_id) {
  return function(dispatch) {
    dispatch({type: actions.SALESFORCE_PUSH.PENDING});
    axios.post(`/salesforce/${verif_id}`, {depo_id: depo_id})
      .then((response) => {
        dispatch({type: actions.SALESFORCE_PUSH.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: actions.SALESFORCE_PUSH.ERROR, payload: err})
      })
  }
}

export function pollData(verifId) {
  return function(dispatch) {
    axios.get("/deposits/1234temp/verifications/"+verifId)
      .then((response) => {
        if (response.data.status === 'running') {
          dispatch({type: actions.FETCH_VERIFICATION.UPDATE, payload: response.data})
        }else{
          dispatch({type: actions.FETCH_VERIFICATION.SUCCESS, payload: response.data})
        }
      })
      .catch((err) => {
        dispatch({type: actions.FETCH_VERIFICATION.ERROR, payload: err})
      })
  }
}

export function fetchData(verifId) {
  return function(dispatch) {
    dispatch({type: actions.FETCH_VERIFICATION.PENDING});
    axios.get("/deposits/1234temp/verifications/"+verifId)
      .then((response) => {
        if (response.data.status == 'done') {
          dispatch({type: actions.FETCH_VERIFICATION.SUCCESS, payload: response.data})
        }else{
          dispatch({type: actions.FETCH_VERIFICATION.UPDATE, payload: response.data})
        }
      })
      .catch((err) => {
        dispatch({type: actions.FETCH_VERIFICATION.ERROR, payload: err})
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/verifActions.js